export default "__VITE_ASSET__CTesnLVa__"